import { LOADING_STATUS } from '../../../../shared/constants/loadingStatus';

export function createListTabState() {
  return {
    listStatus: LOADING_STATUS.IDLE,
    items: [],
    page: 1,
    pageSize: 15,
    count: 0,
    totalPages: 1,
    listRequestId: null,
  };
}

export function createFacetsTabState() {
  return {
    facetsStatus: LOADING_STATUS.IDLE,
    facets: null,
    facetsRequestId: null,
  };
}
